import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import Image from '../elements/Image';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';


const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const Home = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {

  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );



  return (
    <section id="Home"
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left mt-12 mb-12 " data-reveal-container=".split-item">
               
                <h1 className="text-color-primary mt-0 mb-12 center-content">
                 Dogecoin v2
                  </h1>
                     <div className='m-12 mt-12 mb-12 center-content'>
                      <p>
                           Dogecoin v2 is here to revitalize the iconic Elon Musk pup sensation! 
                      </p>

                      <p>
                        After much anticipation, the time has come for DOGE's triumphant return to prominence. 
                      </p>
                      <p>
                            Embrace the evolution, join the thriving community, secure your share, and rise together with Dogecoin v2!
                     </p>
                     <p>
                      CA: 0x47dea215ee41eedf84340f7e1ab501786cff6f62
                     </p>
                  </div>

                      <div className="reveal-from-bottom center-content mt-32 mb-32" data-reveal-delay="600">
                <ButtonGroup>
                  <Button tag="a" color="primary" wideMobile href="https://dexscreener.com/ethereum/0x6ee609d8932b172c750ee6e2b254ab71f447cbf2">
                    Charts
                    </Button>
                  <Button tag="a" color="primary" wideMobile href="https://etherscan.io/address/0x47dea215ee41eedf84340f7e1ab501786cff6f62#code">
                    Contract
                    </Button>
                </ButtonGroup>
              </div>
                </div>




              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/logo.png')}
                  alt="Features split 01"
                  width={528}
                  height={396} />
              </div>
            </div>
        

        
           
        

          </div>
        </div>
      </div>
    </section>
  );
}

Home.propTypes = propTypes;
Home.defaultProps = defaultProps;

export default Home;